import React, { RefObject, useEffect, useRef, useMemo, useState, useCallback  } from 'react';
import withFormState, { FormStateProps } from './states/FormStates';
import ContributietabelLidmaatschapWidgetForm from './widgets/ContributietabelLidmaatschapWidgetForm';
import ContributieBeslisboomWidgetForm from './widgets/ContributieBeslisboomWidgetForm';
import GezinslidmaatschapForm from './widgets/GezinslidmaatschapForm';
import { RenderStep } from './components/FormControlRendering';
import { getResourceString } from '../kentico/resource-strings';
import IncomeRelationWidgetForm from './widgets/IncomeRelationWidgetForm';

export interface WidgetFormProps extends FormStateProps<WidgetFormPageModel> {
  reactId?: string;
  formDefinitions?: FormDefinition;
  sidebarRef?: RefObject<HTMLDivElement>;
  stepsContainerRef?: RefObject<HTMLDivElement>;
  beforeFormRef?: RefObject<HTMLDivElement>;
  props?: any;
}

const WidgetForm: React.FC<WidgetFormProps> = (state) => {
  const beforeFormRef = useRef<HTMLDivElement>(null);

  if(state.fields.length > 0 && state.formLoading) {
    setTimeout(() => {
      state.setFormLoading(false);
    }, 1000);
  }

  useEffect(() => {
    const formDefinition = state.formDefinitions ?? state.pageModel.FormDefinition;
    state.initForms(formDefinition);
  }, []);

  const formReactHasPadding = (formName: string) => {
    switch (formName) {
      case 'MijnFNV_GezinslidUitnodigen_FormsV2':
      case 'CheckJeContributietarief_Introductietarief':
        return true;
      default:
        return false;
    }
  }

  return (
    <div className="form-redesign mijn-fnv">
      {state.formDefinition && (
        <div className="flex-column flex-md-row flex-wrap-reverse">

          <div ref={beforeFormRef}></div>
          <div className="fnv-form__container form-container">
              <form className={`form${formReactHasPadding(state.formDefinition.form.name) ? ` form__react flex` : ``}${state.formLoading ? ` loading-div` : ``}`}>

              {(() => {
                switch (state.formDefinition.form.name) {
                  case "ContributietabelLidmaatschap_Introductietarief":
                    return <ContributietabelLidmaatschapWidgetForm {...state} beforeFormRef={beforeFormRef} />;
                  case "MijnFNV_GezinslidUitnodigen_FormsV2":
                    return <GezinslidmaatschapForm {...state} beforeFormRef={beforeFormRef} stepsContainerRef={state.stepsContainerRef} />;
                  case 'CheckJeContributietarief_Introductietarief':
                    return <ContributieBeslisboomWidgetForm {...state} props={state.props} formDefinitions={state.formDefinition} sidebarRef={state.sidebarRef} beforeFormRef={beforeFormRef} />;
                  case 'MijnFNV_Inkomenssituatie':
                    return <IncomeRelationWidgetForm {...state} props={state.props} />
                  default:
                    return (<div className="col-12 col-sm p-0" ref={state.formFieldsRef}> 
                            {!state.formLoading && <>
                                <RenderStep
                                  fields={state.fields}
                                  formDefinition={state.formDefinitions} 
                                  visibleFields={state.visibleFields} 
                                  currentStepIndex={state.currentStepIndex} 
                                  formData={state.formData} 
                                  setFormData={state.setFormData}
                                  formErrors={state.formErrors} 
                                  handleChange={state.handleChange} 
                                  handleBlur={state.handleBlur}
                                  formSummaryData={null}
                                  navigateToStep={state.setHandleFormStepSpecific}
                                />
                                <button type="submit" className="btn btn-success btn-form-submit mt-4" onClick={state.handleSubmit}>{getResourceString("Form.Send.ButtonCaption")}</button>
                              </>
                            }
                          </div>);
                }
              })()}

              </form>
              
              {state.loading && (
                <div className="loader-new-overlay">
                  <span className="loader-new"></span>
                </div>
              )}
            </div>
        </div>
      )}
    </div>
  );
};

export default withFormState(WidgetForm);